const PlaylistActionTypes = {
  FETCH_USER_PLAYLISTS_START: 'FETCH_USER_PLAYLISTS_START',
  FETCH_USER_PLAYLISTS_SUCCESS: 'FETCH_USER_PLAYLISTS_SUCCESS',
  FETCH_USER_PLAYLISTS_FAILURE: 'FETCH_USER_PLAYLISTS_FAILURE'
};

export default PlaylistActionTypes;
